import { useCallback, useEffect, useState } from 'react';

import { useProductDependencies } from '../../../../../controllers/use-product-dependencies';
import type { Item } from '../../../../../types';
import { DEFAULT_UNSPLASH_QUERY_WORD } from '../../constants';
import type { UnsplashResult } from '../../types';
import { getUnsplashPhotos } from '../unsplash-api';

export const useInitialUnsplashResults = (items: Item[]): UnsplashResult[] | undefined => {
	const [initialUnsplashResults, setInitialUnsplashResults] = useState<
		UnsplashResult[] | undefined
	>([]);

	const { submitError } = useProductDependencies();

	const loadInitialUnsplashResults = useCallback(() => {
		if (initialUnsplashResults?.length === 0) {
			void getUnsplashPhotos(DEFAULT_UNSPLASH_QUERY_WORD, 1, submitError)
				.then((result) => {
					setInitialUnsplashResults(result);
				})
				.catch((_error) => {
					setInitialUnsplashResults(undefined);
				});
		}
	}, [initialUnsplashResults, setInitialUnsplashResults, submitError]);

	useEffect(() => {
		if (items?.length > 0) {
			loadInitialUnsplashResults();
		}
	}, [loadInitialUnsplashResults, items]);

	return initialUnsplashResults;
};
